<template>
    <div class="uk-container uk-container-xlarge">
        <div class="uk-card uk-card-default  uk-width-1-1@m mt-5 p-2">
            <h4>Pointage Horaires</h4>
            <div class="uk-overflow-auto">
                <table class="uk-table uk-table-striped">
                <thead>
                    <tr>
                        <th>Nom du livreur</th>
                        <th>Date </th>
                        <th>Heure d'arrivée</th>
                        <th>Matricule</th>

                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(horaire) in horaires" :key="horaire.id">
                        <td>{{horaire.nom_livreur}}</td>
                        <td>{{horaire.nom_responsable}}</td>
                        <td>{{horaire.adresse}}</td>
                        <td>{{horaire.contact_horaire}}</td>
                        <td>{{horaire.uuid}}</td>
                        <td>{{horaire.commercial_id}}</td>
                        <td>
                            <router-link :to="{path: '/admin/horaire/' + horaire.key }" v-bind:tooltip=" horaire.id"  class="btn btn-default mr-1 uk-box-shadow-large">
                            <span class="" style="color: #5F5F5F" uk-icon="icon:expand; ratio: 0.8"></span>
                            </router-link>
                            <router-link :to="{path: '/admin/horaire/edit/' + horaire.key }" v-bind:tooltip=" horaire.id"  class="btn btn-default mr-1 uk-box-shadow-large">
                            <span class="" style="color: #5F5F5F" uk-icon="icon:pencil; ratio: 0.8"></span>
                            </router-link>
                            <button class="btn btn-default uk-box-shadow-large">
                            <span class="" style="color: #5F5F5F" uk-icon="icon:trash; ratio: 0.8"></span>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
            </div>
        </div>
    </div>
</template>
<script>
import { db, dbstore, auth } from '../../main';
export default {
    data(){
        return{
            horaires:[]
        }
    },
    created () {
    const id = auth.currentUser.uid
    const ref = dbstore.collection('horaires').where('commercial_id', '==', id)
    ref.onSnapshot((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        this.horaires.push({
            key: doc.id,
            nom_horaire: doc.data().nom_horaire,
            nom_responsable: doc.data().nom_responsable,
            adresse: doc.data().adresse,
            contact_horaire:doc.data().contact_horaire,
            type_paiement:doc.data().type_paiement,
            adresse_paiement:doc.data().adresse_paiement,
            id_proprio:doc.data().id_proprio,
            uuid:doc.data().uuid,
            created_at:doc.data().created_at,
            commercial_id:doc.data().commercial_id

        });
        console.log(this.horaires)
      });

    });

  },
}
</script>